import AddOnsItem from '../ViewPatientRegistration/AddOnsItem';
import ViewPackageItem from '../ViewPatientRegistration/ViewPackageItem';
import Invoice from './ServiceItems/Invoice';
import { ClipboardIcon } from '@/assets/svg';
import {
  Grid,
  Typography,
  makeStyles,
  Divider,
  Paper,
  Box,
} from '@material-ui/core';
import { isEmpty } from 'lodash';
import React, { useMemo } from 'react';

const useStyles = makeStyles({
  container: {
    display: 'flex',
  },

  leftContainer: {
    overflowY: 'scroll',
    overflowX: 'hidden',
    padding: '36px 20px',
    flex: '1',
    borderRight: '1px solid #F1F1F1',
    height: 'calc(100vh - 283px)',
  },

  rightContainer: {
    overflow: 'scroll',
    padding: '16px 40px',
    display: 'flex',
    height: 'calc(100vh - 283px)',
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 16,
    fontSize: 20,
    gap: 8,
  },
  disabledSwitch: {
    pointerEvents: 'none',
    cursor: 'not-allowed',
  },
});

const sortByCategory = (list) => {
  return [...(list || [])].sort((a, b) => {
    const categoryA = (a.category || '').toLowerCase();
    const categoryB = (b.category || '').toLowerCase();
    return categoryA.localeCompare(categoryB);
  });
};

const ViewSelectPackage = ({
  totalCost,
  totalAmountDefault,
  formValue,
  paymentStatus,
  packageDetail,
  lstOptionalTests,
  hasOffSiteTest = true,
  dataInfo,
  restrictedTestIds,
  apptData,
  projectInfo,
  originalLstTestsForPreCalculate,
}) => {
  const classes = useStyles();
  const lstProfiles = dataInfo?.lstProfiles || [];
  const lstTests = dataInfo?.lstTests || [];
  const newListProfiles = useMemo(() => {
    if (!lstProfiles.length && !lstTests.length) return [];
    let newList = [];
    if (lstProfiles.length > 0) {
      newList.push({
        category: 'Profiles',
        items: lstProfiles,
      });
    }
    const combinedList = newList.concat(lstTests || []);
    // Sort by category alphabetically
    return sortByCategory(combinedList);
  }, [lstProfiles, lstTests]);

  const sortedLstTests = useMemo(() => {
    return sortByCategory(lstTests);
  }, [lstTests]);

  return (
    <Paper square variant="outlined" className={classes.container}>
      <Box
        flexDirection="column"
        className={classes.leftContainer}
        gridGap={16}
      >
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography className={classes.title}>
              <ClipboardIcon style={{ color: '#666666' }} />
              Selected packages
            </Typography>
          </Grid>
          {hasOffSiteTest && !isEmpty(formValue?.lstPackages) && (
            <Grid item xs={12}>
              <ViewPackageItem
                dataInfo={dataInfo}
                packageDetail={packageDetail}
                ignoredTests={formValue?.ignoredTests}
                ignoredProfiles={formValue?.ignoredProfiles}
                restrictedTestIds={restrictedTestIds}
              />
            </Grid>
          )}

          {/* {hasOffSiteTest &&
            !isEmpty(formValue.lstPackages) &&
            !isEmpty(formValue.lstTests) && (
              <Grid item xs={12}>
                <Divider light variant="middle" />
              </Grid>
            )}

          {!isEmpty(formValue.lstTests) && (
            <Grid item xs={12}>
              <AddOnsItem listData={formValue.lstTests} />
            </Grid>
          )} */}

          {!isEmpty(dataInfo.lstPackages) && !isEmpty(dataInfo.lstProfiles) && (
            <Grid item xs={12}>
              <Divider light variant="middle" />
            </Grid>
          )}
          {!isEmpty(dataInfo.lstProfiles) && !apptData.isFollowUp ? (
            <Grid item xs={12}>
              <AddOnsItem listData={newListProfiles} />
            </Grid>
          ) : !isEmpty(dataInfo.lstTests) ? (
            <Grid item xs={12}>
              <AddOnsItem listData={sortedLstTests} />
            </Grid>
          ) : null}
        </Grid>
      </Box>
      <Box className={classes.rightContainer}>
        <Invoice
          totalCost={totalCost}
          totalAmountDefault={totalAmountDefault}
          dataExist={formValue}
          packageInfor={packageDetail}
          paymentStatus={paymentStatus}
          lstOptionalTests={lstOptionalTests}
          restrictedTestIds={restrictedTestIds}
          dataInfo={dataInfo}
          apptData={apptData}
          projectInfo={projectInfo}
          staffType={formValue?.staffType || dataInfo?.staffType}
          originalLstTestsForPreCalculate={originalLstTestsForPreCalculate}
        />
      </Box>
    </Paper>
  );
};

export default ViewSelectPackage;
